import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function BusinessSupport() {
  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-20 pb-16 bg-gradient-to-br from-teal-50 to-blue-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <nav className="text-sm text-gray-600 mb-4">
              <Link to="/" className="hover:text-teal-600 cursor-pointer">ホーム</Link>
              <span className="mx-2">/</span>
              <span className="text-gray-800">再生医療事業への支援</span>
            </nav>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
              再生医療事業への支援
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              クリニックや研究機関の立ち上げから運用まで、再生医療事業の成功をトータルサポートいたします。
            </p>
          </div>
          
          <div className="mb-12">
            <img 
              src="https://public.readdy.ai/ai/img_res/2a7a22223e679fb0a09a393ce15c25b9.jpg"
              alt="再生医療クリニック"
              className="w-full h-96 object-cover rounded-2xl shadow-xl"
            />
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800">
            支援サービス一覧
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-xl p-8 shadow-lg">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-600 text-white rounded-full mb-6 mx-auto">
                <i className="ri-building-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-center mb-4 text-gray-800">施設構築支援</h3>
              <ul className="space-y-3 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5"></i>
                  <span>クリーンルーム設計・構築</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5"></i>
                  <span>必要設備の選定・導入</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5"></i>
                  <span>法規制対応サポート</span>
                </li>
              </ul>
            </div>
            
            <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-xl p-8 shadow-lg">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-600 text-white rounded-full mb-6 mx-auto">
                <i className="ri-team-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-center mb-4 text-gray-800">人材育成</h3>
              <ul className="space-y-3 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5"></i>
                  <span>細胞培養技術者の育成</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5"></i>
                  <span>技術指導・研修プログラム</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5"></i>
                  <span>運用マニュアル作成</span>
                </li>
              </ul>
            </div>
            
            <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-xl p-8 shadow-lg">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-600 text-white rounded-full mb-6 mx-auto">
                <i className="ri-file-text-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-center mb-4 text-gray-800">認可取得支援</h3>
              <ul className="space-y-3 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5"></i>
                  <span>再生医療等製品届出</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5"></i>
                  <span>細胞加工施設許可</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5"></i>
                  <span>必要書類作成代行</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Detailed Process */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-teal-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800">
            事業立ち上げプロセス
          </h2>
          
          <div className="space-y-12">
            <div className="flex items-start gap-8">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-teal-600 text-white rounded-full flex items-center justify-center font-bold text-xl">1</div>
              </div>
              <div className="flex-1">
                <h3 className="text-2xl font-bold mb-4 text-gray-800">初期相談・事業計画策定</h3>
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <p className="text-gray-700 mb-4">お客様のご要望をお聞きし、最適な事業計画を策定いたします。</p>
                    <ul className="space-y-2 text-sm text-gray-600">
                      <li>• 事業規模・対象治療の検討</li>
                      <li>• 投資計画・収支予測</li>
                      <li>• スケジュール策定</li>
                    </ul>
                  </div>
                  <img 
                    src="https://readdy.ai/api/search-image?query=Professional%20business%20meeting%20with%20medical%20executives%20and%20consultants%20discussing%20regenerative%20medicine%20clinic%20business%20plan%2C%20modern%20conference%20room%20with%20charts%20and%20documents%2C%20healthcare%20business%20planning%20session%20with%20laptops%20and%20presentation%20materials%2C%20professional%20consultation%20for%20medical%20facility%20development&width=400&height=256&seq=business-consultation-meeting-2024&orientation=landscape"
                    alt="事業計画策定"
                    className="w-full h-64 object-cover rounded-lg"
                  />
                </div>
              </div>
            </div>
            
            <div className="flex items-start gap-8">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-teal-600 text-white rounded-full flex items-center justify-center font-bold text-xl">2</div>
              </div>
              <div className="flex-1">
                <h3 className="text-2xl font-bold mb-4 text-gray-800">施設設計・許可申請</h3>
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <p className="text-gray-700 mb-4">法規制に準拠した施設設計と各種許可申請を代行いたします。</p>
                    <ul className="space-y-2 text-sm text-gray-600">
                      <li>• クリーンルーム設計</li>
                      <li>• 設備仕様書作成</li>
                      <li>• 各種申請書類作成</li>
                    </ul>
                  </div>
                  <img 
                    src="https://readdy.ai/api/search-image?query=Modern%20cleanroom%20facility%20construction%20and%20design%20for%20regenerative%20medicine%2C%20architects%20and%20engineers%20reviewing%20blueprints%20for%20medical%20laboratory%2C%20sterile%20environment%20construction%20with%20HEPA%20filtration%20systems%2C%20clean%20white%20medical%20facility%20under%20construction%20with%20advanced%20ventilation%20and%20safety%20systems&width=400&height=256&seq=cleanroom-construction-design-2024&orientation=landscape"
                    alt="施設設計"
                    className="w-full h-64 object-cover rounded-lg"
                  />
                </div>
              </div>
            </div>
            
            <div className="flex items-start gap-8">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-teal-600 text-white rounded-full flex items-center justify-center font-bold text-xl">3</div>
              </div>
              <div className="flex-1">
                <h3 className="text-2xl font-bold mb-4 text-gray-800">設備導入・人材研修</h3>
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <p className="text-gray-700 mb-4">必要設備の導入から技術者育成まで一貫してサポートいたします。</p>
                    <ul className="space-y-2 text-sm text-gray-600">
                      <li>• 培養装置・分析機器導入</li>
                      <li>• 技術者研修プログラム</li>
                      <li>• 運用マニュアル作成</li>
                    </ul>
                  </div>
                  <img 
                    src="https://readdy.ai/api/search-image?query=Medical%20equipment%20installation%20and%20staff%20training%20in%20regenerative%20medicine%20facility%2C%20technicians%20setting%20up%20advanced%20cell%20culture%20equipment%2C%20professional%20training%20session%20for%20medical%20laboratory%20staff%2C%20modern%20biotechnology%20equipment%20installation%20with%20microscopes%20and%20incubators%2C%20clean%20medical%20environment%20with%20new%20equipment%20setup&width=400&height=256&seq=equipment-training-setup-2024&orientation=landscape"
                    alt="設備導入・研修"
                    className="w-full h-64 object-cover rounded-lg"
                  />
                </div>
              </div>
            </div>
            
            <div className="flex items-start gap-8">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-teal-600 text-white rounded-full flex items-center justify-center font-bold text-xl">4</div>
              </div>
              <div className="flex-1">
                <h3 className="text-2xl font-bold mb-4 text-gray-800">運用開始・継続サポート</h3>
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <p className="text-gray-700 mb-4">事業開始後も継続的な技術サポートを提供いたします。</p>
                    <ul className="space-y-2 text-sm text-gray-600">
                      <li>• 定期的な技術指導</li>
                      <li>• 品質管理システム構築</li>
                      <li>• 新技術導入支援</li>
                    </ul>
                  </div>
                  <img 
                    src="https://readdy.ai/api/search-image?query=Operational%20regenerative%20medicine%20clinic%20with%20medical%20staff%20treating%20patients%2C%20active%20stem%20cell%20therapy%20facility%20with%20doctors%20and%20technicians%20working%2C%20successful%20medical%20clinic%20operation%20with%20patient%20care%20and%20advanced%20treatments%2C%20professional%20healthcare%20team%20providing%20ongoing%20medical%20services&width=400&height=256&seq=clinic-operation-ongoing-2024&orientation=landscape"
                    alt="運用開始"
                    className="w-full h-64 object-cover rounded-lg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Global Partnerships */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800">
            国際連携・海外展開支援
          </h2>
          
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-2xl font-bold mb-6 text-gray-800">
                Exosome Oneの支援サービス
              </h3>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Exosome Oneは、再生医療事業の成功に必要なすべての要素を、
                ワンストップでサポートします。
              </p>
              
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <i className="ri-global-line text-2xl text-teal-600 mt-1"></i>
                  <div>
                    <h4 className="font-bold text-lg mb-2">海外進出支援</h4>
                    <p className="text-sm text-gray-600">現地法規制への対応、パートナー企業との連携支援</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-3">
                  <i className="ri-team-line text-2xl text-teal-600 mt-1"></i>
                  <div>
                    <h4 className="font-bold text-lg mb-2">国際共同研究</h4>
                    <p className="text-sm text-gray-600">海外研究機関との共同研究プロジェクト推進</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-3">
                  <i className="ri-exchange-line text-2xl text-teal-600 mt-1"></i>
                  <div>
                    <h4 className="font-bold text-lg mb-2">技術移転</h4>
                    <p className="text-sm text-gray-600">先進技術の海外展開と現地化サポート</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=International%20medical%20collaboration%20with%20diverse%20healthcare%20professionals%20from%20different%20countries%20working%20together%2C%20global%20regenerative%20medicine%20conference%20with%20scientists%20from%20Japan%2C%20China%2C%20and%20UAE%2C%20modern%20international%20medical%20facility%20with%20flags%20and%20cultural%20diversity%2C%20worldwide%20healthcare%20partnership%20meeting%20with%20advanced%20medical%20technology%20sharing&width=600&height=400&seq=international-medical-collaboration-2024&orientation=landscape"
                alt="国際連携"
                className="w-full h-96 object-cover rounded-2xl shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Success Cases */}
      <section className="py-20 bg-gradient-to-br from-teal-50 to-blue-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800">
            Exosome Oneの支援実績
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-6 shadow-lg">
              <div className="text-center mb-4">
                <div className="text-3xl font-bold text-teal-600 mb-2">15+</div>
                <p className="text-gray-700 font-medium">支援施設数</p>
              </div>
              <p className="text-sm text-gray-600 text-center">
                クリニック・研究機関の立ち上げ支援実績
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-lg">
              <div className="text-center mb-4">
                <div className="text-3xl font-bold text-teal-600 mb-2">5</div>
                <p className="text-gray-700 font-medium">海外展開国</p>
              </div>
              <p className="text-sm text-gray-600 text-center">
                国際的なパートナーシップによる事業展開
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-lg">
              <div className="text-center mb-4">
                <div className="text-3xl font-bold text-teal-600 mb-2">100%</div>
                <p className="text-gray-700 font-medium">認可取得率</p>
              </div>
              <p className="text-sm text-gray-600 text-center">
                必要な許可・認可の取得成功率
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-teal-600 to-blue-600 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            再生医療事業の立ち上げをお考えですか？
          </h2>
          <p className="text-lg mb-8 opacity-95">
            豊富な経験と専門知識を持つExosome Oneが、<br />
            あなたの再生医療事業の成功を全力でサポートいたします。
          </p>
          <Link 
            to="/contact" 
            className="inline-flex items-center gap-3 bg-white text-teal-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-colors shadow-xl cursor-pointer whitespace-nowrap"
          >
            <i className="ri-mail-line text-2xl"></i>
            お問い合わせ・相談予約
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}